import { Formik, FieldArray, Field } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { AiFillMinusSquare } from "react-icons/ai";
import { useEffect, useRef } from "react";
import Alert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { TiDelete } from "react-icons/ti";
import { clearCountryMedia } from "../../../../../store/slices/country";
import { ImageTooltip } from "../../../../utils";
import { ImageValidation } from "../../../../utils/validations";
import SaveAndSaveNext from "../../../utils/saveAndSaveNext";

const GalleryForm = (props) => {
  const firstErrorRef = useRef(null);
  const dispatch = useDispatch();
  const { putCountryMediaError, message, putCountryMediaLoading } = useSelector(
    (state) => state.cmsCountry
  );
  useEffect(() => {
    if (message) {
      setTimeout(() => {
        dispatch(clearCountryMedia());
      }, 5000);
    }
  }, [message]);
  return (
    <div>
      <div className={"notification_popup"}>
        {message && (
          <Alert severity={putCountryMediaError ? `error` : `success`}>
            {" "}
            {message}
          </Alert>
        )}
      </div>

      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validate={async (values) => {
          const errors = {};
          for (let index = 0; index < values.banner_images.length; index++) {
            const element = values.banner_images[index];
            if (element?.image && typeof element.image !== "string") {
              let imageParams = {};
              imageParams.minWidth = 583;
              imageParams.minHeight = 282;
              imageParams.maxSize = 1024 * 1024; // 1 MB
              imageParams.file = element.image;
              const validationResult = await ImageValidation(imageParams);
              errors[`banner_images.${index}.image`] = validationResult;
            }
          }
          for (let index = 0; index < values.country_images.length; index++) {
            const element = values.country_images[index];
            if (element?.image && typeof element.image !== "string") {
              let imageParams = {};
              imageParams.minWidth = 720;
              imageParams.minHeight = 480;
              imageParams.maxSize = 1024 * 1024; // 1 MB
              imageParams.file = element.image;
              const validationResult = await ImageValidation(imageParams);
              errors[`country_images.${index}.image`] = validationResult;
            }
          }
          Object.keys(errors).forEach((key) => {
            if (!errors[key]) {
              delete errors[key];
            }
          });
          return errors;
        }}
        onSubmit={(values) => {
          props.submit(values);
        }}
      >
        {({
          values,
          handleSubmit,
          setFieldValue,
          errors,
          handleBlur,
          setTouched,
          touched,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className={"basic_details_country"}>
              <div className={"examfilter"}>
                <h4 className={"examfilter_heading"}>Banner Image/Animation</h4>
                <FieldArray name="banner_images">
                  {({ remove, push }) => (
                    <div>
                      {values.banner_images?.map((element, index) => (
                        <>
                          <Row>
                            <Col md={10}>
                              <Form.Group
                                controlId={`banner_images_${index}`}
                                className="mb-1"
                              >
                                <Form.Label>Upload Image</Form.Label>
                                <Form.Control
                                  type="file"
                                  name={`banner_images.${index}.image`}
                                  onBlur={handleBlur}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `banner_images.${index}.image`,
                                      e.target.files[0]
                                    );
                                  }}
                                />
                                {typeof values.banner_images[index].image ==
                                  "string" &&
                                  values.banner_images[index].image != "" && (
                                    <div className="media_image_container mt-2">
                                      <ImageTooltip
                                        href={values.banner_images[index].image}
                                      />
                                      <span
                                        className={"delete_image_btn"}
                                        onClick={() => {
                                          setFieldValue(
                                            `banner_images.${index}.image`,
                                            null
                                          );
                                        }}
                                      >
                                        <TiDelete />
                                      </span>
                                    </div>
                                  )}
                                {errors[`banner_images.${index}.image`] &&
                                  touched[`banner_images`]?.[index]?.image && (
                                    <div ref={firstErrorRef} className="error">
                                      {errors[`banner_images.${index}.image`]}
                                    </div>
                                  )}
                              </Form.Group>
                            </Col>
                            <Col md className="bottom_right_button_container">
                              <div className={"imageField_fieldArray"}>
                                <div className={"imageField_add"}>
                                  {values.banner_images?.length > 1 && (
                                    <span
                                      className={"imageField_minus_icon"}
                                      onClick={() => {
                                        remove(index);
                                      }}
                                    >
                                      <AiFillMinusSquare />
                                    </span>
                                  )}
                                  {index ==
                                    values.banner_images?.length - 1 && (
                                    <span
                                      className={"imageField_add_icon"}
                                      onClick={() =>
                                        push({
                                          image: "",
                                        })
                                      }
                                    >
                                      <BsFillPlusSquareFill />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ))}
                    </div>
                  )}
                </FieldArray>
                <Row>
                  <Col>
                    <Form.Group controlId="logo" className="mb-1">
                      <Form.Label>Upload Logo</Form.Label>
                      <Form.Control
                        type="file"
                        name="logo"
                        onChange={(e) => {
                          setFieldValue("logo", e.target.files[0]);
                        }}
                      />
                      {typeof values.logo == "string" && values.logo != "" && (
                        <div className="media_image_container mt-2">
                          <ImageTooltip href={values.logo} />
                          <span
                            className={"delete_image_btn"}
                            onClick={() => {
                              setFieldValue("logo", null);
                            }}
                          >
                            <TiDelete />
                          </span>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </div>
            <div className={"basic_details_country"}>
              <div className={"examfilter"}>
                <h4 className={"examfilter_heading"}>Image</h4>
                <FieldArray name="country_images">
                  {({ remove, push }) => (
                    <div>
                      {values.country_images?.map((element, index) => (
                        <>
                          <Row>
                            <Col md={10}>
                              <Form.Group
                                controlId={`country_images_${index}`}
                                className="mb-1"
                              >
                                <Form.Label>Upload Image</Form.Label>
                                <Form.Control
                                  type="file"
                                  name={`country_images.${index}.image`}
                                  onBlur={handleBlur}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `country_images.${index}.image`,
                                      e.target.files[0]
                                    );
                                  }}
                                />
                                {typeof values.country_images[index].image ==
                                  "string" &&
                                  values.country_images[index].image != "" && (
                                    <div className="media_image_container mt-2">
                                      <ImageTooltip
                                        href={values.country_images[index].image}
                                      />
                                      <span
                                        className={"delete_image_btn"}
                                        onClick={() => {
                                          setFieldValue(
                                            `country_images.${index}.image`,
                                            null
                                          );
                                        }}
                                      >
                                        <TiDelete />
                                      </span>
                                    </div>
                                  )}
                                {errors[`country_images.${index}.image`] &&
                                  touched[`country_images`]?.[index]?.image && (
                                    <div ref={firstErrorRef} className="error">
                                      {errors[`country_images.${index}.image`]}
                                    </div>
                                  )}
                              </Form.Group>
                            </Col>
                            <Col className="bottom_right_button_container">
                              <div className={"imageField_fieldArray"}>
                                <div className={"imageField_add"}>
                                  {values.country_images?.length > 1 && (
                                    <span
                                      className={"imageField_minus_icon"}
                                      onClick={() => {
                                        remove(index);
                                      }}
                                    >
                                      <AiFillMinusSquare />
                                    </span>
                                  )}
                                  {index ==
                                    values.country_images?.length - 1 && (
                                    <span
                                      className={"imageField_add_icon"}
                                      onClick={() =>
                                        push({
                                          image: "",
                                        })
                                      }
                                    >
                                      <BsFillPlusSquareFill />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ))}
                    </div>
                  )}
                </FieldArray>
              </div>
            </div>
            <div className={"basic_details_country"}>
              <div className={"examfilter"}>
                <h4 className={"examfilter_heading"}>Video</h4>
                <FieldArray name="country_videos">
                  {({ insert, remove, push }) => (
                    <div>
                      {values.country_videos?.map((element, index) => (
                        <>
                          <Row>
                            <Col md={6}>
                              <Form.Group
                                className="mb-3"
                                controlId={`caption_${index}`}
                              >
                                <Form.Label>Add Caption For Video</Form.Label>
                                <Form.Control
                                  type="text"
                                  name={`country_videos.${index}.caption`}
                                  className={"input_pd"}
                                  value={values.country_videos[index].caption}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `country_videos.${index}.caption`,
                                      e.target.value
                                    );
                                  }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={10}>
                              <Form.Group
                                className="mb-3"
                                controlId={`video_url_${index}`}
                              >
                                <Form.Control
                                  placeholder="Video Embedded Code"
                                  as="textarea"
                                  rows={5}
                                  name={`country_videos.${index}.video_url`}
                                  className={"input_pd"}
                                  value={values.country_videos[index].video_url}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `country_videos.${index}.video_url`,
                                      e.target.value
                                    );
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col
                              md={2}
                              className="bottom_right_button_container"
                            >
                              <div className={"imageField_fieldArray"}>
                                <div className={"imageField_add"}>
                                  {values.country_videos?.length > 1 && (
                                    <span
                                      className={"imageField_minus_icon"}
                                      onClick={() => {
                                        remove(index);
                                      }}
                                    >
                                      <AiFillMinusSquare />
                                    </span>
                                  )}
                                  {index ==
                                    values.country_videos?.length - 1 && (
                                    <span
                                      className={"imageField_add_icon"}
                                      onClick={() =>
                                        push({
                                          video_url: "",
                                          caption: "",
                                        })
                                      }
                                    >
                                      <BsFillPlusSquareFill />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ))}
                    </div>
                  )}
                </FieldArray>
              </div>
            </div>
            <div className={"domain"}>
              <div className={"examfilter"}>
                <Row>
                  {values.last_updated && (
                    <span>Last Updated date: {values.last_updated}</span>
                  )}
                </Row>
                <Row>
                  {values.updated_by && (
                    <span>Updated by: {values.updated_by} </span>
                  )}
                </Row>
              </div>
            </div>

            <Row>
              <Col className="mt-3">
                <SaveAndSaveNext
                  firstErrorRef={firstErrorRef}
                  setTouched={setTouched}
                  errors={errors}
                  setSaveAndNext={props.setSaveAndNext}
                  loading={putCountryMediaLoading}
                />
              </Col>
            </Row>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default GalleryForm;
